export default __webpack_public_path__ + "static/media/292.af23fa22.png";